import { createApp } from 'vue'
import App from './App.vue'
// Step 4: Import Bootstrap
import 'bootstrap/dist/css/bootstrap.css'

createApp(App).mount('#app')
